// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__87sDp","RoundedButton":"style_RoundedButton__6rrH3","RoundedButtonPlay":"style_RoundedButtonPlay__le1Yz"};